import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSession, getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import translate from "@insite/client-framework/Translate";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";
import { ProductBrandStyles } from "@insite/content-library/Components/ProductBrand";
import { ProductDescriptionStyles } from "@insite/content-library/Components/ProductDescription";
import Typography, { TypographyPresentationProps, TypographyProps } from "@insite/mobius/Typography";
import { getProp } from "@insite/mobius/utilities";
import Checkbox from "@insite/mobius/Checkbox";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import ADIProductDescription from "@NA/Components/RecentlyPurchasedProduct/ADIProductDescription";
import ADIProductImage from "@NA/Components/RecentlyPurchasedProduct/ADIProductImage";
import addProductToCompare from "@insite/client-framework/Store/Components/CompareProductsDrawer/Handlers/AddProductToCompare";
import removeProductFromCompare from "@insite/client-framework/Store/Components/CompareProductsDrawer/Handlers/RemoveProductFromCompare";
import ADIProductSaleInfo from "@NA/Components/ProductList/ADIProductSaleInfo";
import React, { useEffect } from "react";
import { connect, ResolveThunks, useSelector } from "react-redux";
import { css } from "styled-components";
import ADIProductBrandName from "@NA/Components/RecentlyPurchasedProduct/ADIProductBrandName";
import ADIProductPartNumbers, {
    ADIProductPartNumbersStyles,
} from "@NA/Components/RecentlyPurchasedProduct/ADIProductPartNumbers";
import ADIProductPrice from "@NA/Components/RecentlyPurchasedProduct/ADIProductPrice";
import ADIProductDeliveryInfo from "@NA/Components/RecentlyPurchasedProduct/ADIProductDeliveryInfo";
import ADIProductAvailability from "@NA/Components/RecentlyPurchasedProduct/ADIProductAvailability";
import ADIProductAddToCartButton, {
    AdiProductAddToCartButtonStyles,
} from "@NA/Components/RecentlyPurchasedProduct/ADIProductAddToCartButton";
import parse from "html-react-parser";
import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import ADIColors from "@NA/Utils/ADIColors";
import { ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import CustomAddToList from "@NA/Components/RecentlyPurchasedProduct/CustomAddToList";
import FilterDown from "@NA/Icons/FilterDown";
import Button from "@insite/mobius/Button";
import Clickable from "@insite/mobius/Clickable";
import CrossIcon from "@NA/Icons/CrossIcon";
import siteMessage from "@insite/client-framework/SiteMessage";
import Modal, { ModalPresentationProps } from "@insite/mobius/Modal";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import { getProductIdsForCompare } from "@insite/client-framework/Store/Components/CompareProductsDrawer/CompareProductsDrawerSelectors";
import Hidden from "@insite/mobius/Hidden";
import CustomApplicationState from "@NA/Store/Data/CustomApplicationState/CustomApplicationState";
import { getPurchasedProductInfoById } from "@NA/Store/Selector/ADIMyPurchaseHistorySelectors";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import Link from "@insite/mobius/Link";
import { pushDealerAuthDataToDataLayer } from "@NA/Overrides/Common/Utilities/CustomTracking";

interface OwnProps {
    product: ProductModel;
    productLine: ProductInfo | undefined;
    view: string;
    showBrand: boolean;
    showPartNumbers: boolean;
    showPrice: boolean;
    showAvailability: boolean;
    extendedStyles?: ADIProductListCardStyles;
    showCompare?: boolean;
    sourceName: string;
}

const mapStateToProps = (state: CustomApplicationState, ownProps: OwnProps) => {
    const catalogRootPath = state.context.settings.settingsCollection.productSettings.catalogUrlPath;
    function getIsProductCompareFull(state: ApplicationState) {
        return state.components.compareProductsDrawer.productsIds.length >= 3;
    }
    const adiUserRoles = state.ADIGlobalData.ADIUserRoleStore;
    let customerNumber = "";
    const billToId = getSession(state)?.billToId;
    if (billToId) {
        customerNumber = state.data.billTos.byId[billToId]?.customerNumber;
    }
    return {
        state,
        productSettings: getSettingsCollection(state).productSettings,
        isAuthenticated: state.context.session.isAuthenticated,
        session: getSession(state),
        productIds: getProductIdsForCompare(state),
        isProductCompareFull: getIsProductCompareFull(state),
        productComparePageLink: getPageLinkByPageType(state, "ProductComparePage"),
        catalogRootPath: catalogRootPath.endsWith("/") ? catalogRootPath.slice(0, -1) : catalogRootPath,
        showADIAddToCart: (adiUserRoles.fullAccess && adiUserRoles.accounting) || adiUserRoles.fullAccess,
        showADIAddToList: (adiUserRoles.fullAccess && adiUserRoles.accounting) || adiUserRoles.fullAccess,
        productInfo: getPurchasedProductInfoById(state, ownProps.product.id),
        customerNumber,
    };
};

const mapDispatchToProps = {
    addProductToCompare,
    removeProductFromCompare,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface ADIProductListCardStyles {
    wrapper?: InjectableCss;
    imageWrapper?: InjectableCss;
    contentWrapper?: InjectableCss;
    actionWrapper?: InjectableCss;
    signInDealerPrice?: InjectableCss;
    sponsoredText?: TypographyPresentationProps;
    brandStyles?: ProductBrandStyles;
    descriptionStyles?: ProductDescriptionStyles;
    productPartNumberStyle?: ADIProductPartNumbersStyles;
    featuresContainer?: InjectableCss;
    features?: InjectableCss;
    featuresTitle?: TypographyProps;
    addToListWrapper?: InjectableCss;
    addToListText?: TypographyProps;
    addToCartStyles?: AdiProductAddToCartButtonStyles;
    compareWarningPopup?: ModalPresentationProps;
    checkBoxContainerStyle?: InjectableCss;
    CompareButtonContainer?: InjectableCss;
    availabilityByWarehouseModal?: ModalPresentationProps;
    dealerBtnWrapper?: InjectableCss;
    dealerBtn?: InjectableCss;
    certifiedBtn?: InjectableCss;
    VerificationText?: TypographyPresentationProps
}

export const adiProductListCardStyles: ADIProductListCardStyles = {
    VerificationText: {
        css: css`
                           
                                text-transform: none !important;
                                font-size: 14px !important;
                                font-weight: bold;
                                color: ${ADIColors.blue5} !important;                              
                            }
                        `,
    },
    dealerBtnWrapper: {
        css: css`
            text-align: center;
            padding-top: 10px;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        css`
                            padding-top: 10px;
                        `,
                    ],
                    "max",
                );
            }}
        `,
    },
    dealerBtn: {
        css: css`
            font-size: 16px;
            font-weight: bold;
            color: #2d2926;
        `,
    },
    certifiedBtn: {
        css: css`
            font-size: 14px;
            font-weight: bold;
            color: #006ae3;
            padding-bottom: 10px;
        `,
    },
    wrapper: {
        css: css`
            display: flex;
            flex-direction: row;
            width: 100%;
            height: 100%;
            border: 1px solid ${getColor("text.disabled")};
            border-radius: 5px;
            position: relative;
            padding-bottom: 20px;
            padding-top: 26px;
        `,
    },
    imageWrapper: {
        css: css`
            margin: 0;
            padding: 10px;
            width: 25%;
            position: relative;
            img {
                max-height: 160px;
                max-width: 231px;
                height: 160px;
                width: 160px;
                margin: 0 auto;
            }
        `,
    },
    sponsoredText: {
        css: css`
            font-size: 0.9em;
            opacity: 0.5;
            position: absolute;
            top: 12px;
        `,
    },
    contentWrapper: {
        css: css`
            padding: 10px 15px;
            width: 50%;
        `,
    },
    actionWrapper: {
        css: css`
            padding: 60px 15px 0px;
            width: 25%;
        `,
    },
    signInDealerPrice: {
        css: css`
            border-top: 1px solid ${getColor("text.disabled")};
            text-align: center;
            padding: 20px 0;
            cursor: pointer;
            transition: 0.2s ease;
            margin-top: auto;
            position: absolute;
            bottom: 0;
            width: 100%;
            margin-top: 30px;
            :hover {
                background-color: ${getColor("primary")};
                span {
                    color: ${ADIColors.white};
                }
            }
        `,
    },
    descriptionStyles: {
        productDetailLink: {
            css: css`
                width: 100%;
            `,
            typographyProps: {
                size: 16,
                css: css`
                    height: auto;
                `,
            },
        },
    },
    productPartNumberStyle: {
        partNumber: {
            size: 12,
            weight: 600,
            css: css`
                color: ${ADIColors.gray4};
            `,
        },
    },
    features: {
        css: css`
            ul {
                padding-left: 25px;
                margin-top: 11px;
            }
            li {
                font-weight: 400;
                font-stretch: normal;
                font-style: normal;
                line-height: 22px;
                letter-spacing: normal;
                font-size: ${getProp("theme.typography.headerSecondary.size")};
                color: ${ADIColors.gray4};
                padding-bottom: 0;
                list-style: disc;
            }
        `,
    },
    featuresTitle: {
        as: "h3",
        css: css`
            font-size: ${getProp("theme.typography.headerSecondary.size")};
            margin-top: 11px;
            margin-bottom: 10px;
            line-height: normal;
            color: ${ADIColors.darkBlue1};
            font-weight: 700;
        `,
    },
    addToListWrapper: {
        css: css`
            position: relative;
            display: inline-block;
            margin-top: 5px;
        `,
    },
    addToListText: {
        as: "span",
        css: css`
            color: ${ADIColors.darkBlue1};
            font-weight: 600;
            font-size: ${getProp("theme.typography.headerSecondary.size")};
            cursor: pointer;
            position: relative;
            svg {
                width: 13px;
                height: 7px;
                margin-left: 12px;
            }
        `,
    },
    addToCartStyles: {
        addToCartButton: {
            css: css`
                border-radius: 4px;
                width: 100%;
                margin-top: 10px;
            `,
        },
        container: {
            css: css`
                display: flex;
                width: 100%;
                border-top: none;
                border: solid 1px ${getColor("primary")};
                border-radius: 4px;
                height: 40px;
                margin-top: 10px;
            `,
        },
        icons: {
            css: css`
                width: 35%;
                display: flex;
                justify-content: center;
                align-items: center;
                cursor: pointer;
                transition: all 0.2s ease;
                min-height: initial;
                svg {
                    width: 20px;
                    height: 20px;
                    position: absolute;
                }

                :hover {
                    background-color: ${getColor("primary")};
                    svg {
                        stroke: ${ADIColors.white};
                    }
                }
            `,
        },
        iconadd: {
            css: css`
                 height: 39px;
                 min-height: 39px;
            `,
        },
        icondelete: {
            css: css`
                height: 39px;
                min-height: 39px;
            `,
        },
        field: {
            css: css`
                width: 75%;
                border-left: solid 1px ${getColor("primary")};
                border-right: solid 1px ${getColor("primary")};
                [class^="FormFieldStyle-"] {
                    height: 100%;
                    width: 100%;
                    display: block;
                }
                [class^="FormInputWrapper-"] {
                    height: 100%;
                    margin: 0 !important;

                    input {
                        display: block;
                        width: 100%;
                        border-radius: 0 !important;
                        border: 0;
                        text-align: center;
                        border: 1px solid ${getColor("text.disabled")};
                        height: 100%;
                        border-top: 0 !important;
                        border-bottom: 0 !important;
                        padding: 0 !important;
                        margin-top: 0px!important;
                    }
                }
            `,
        },
    },
    checkBoxContainerStyle: {
        css: css`
            position: absolute;
            bottom: 0;
            left: 35%;
            gap: 10px;
        `,
    },
    compareWarningPopup: {
        sizeVariant: "small",
        size: 600,
        closeButtonIconProps: {
            src: CrossIcon,
            size: 20,
        },
        cssOverrides: {
            modalContainer: css`
                > div {
                    box-shadow: 0 1px 9px 0 rgba(0, 0, 0, 0.14);
                    border-radius: 7px;
                    max-width: 650px;
                    width: 65%;
                    height: auto;
                    top: 20%;
                    position: absolute;
                    ${({ theme }) => {
                    return breakpointMediaQueries(
                        theme, [css`top: 10%;width: 90%;`, css`top: 10%;width: 90%;`, css`top: 20%;width: 70%;`,],);
                }}
                }
            `,
            modalTitle: css`
                border-bottom: 0;
                padding: 20px 20px 5px;
                span {
                    font-size: 28px;
                    font-weight: bold;
                    font-style: normal;
                    line-height: normal;
                    letter-spacing: normal;
                    color: ${ADIColors.darkBlue1};
                    width: calc(100% - 35px);
                    display: inline-block;
                    text-transform: none;
                }
                button {
                    position: absolute;
                    top: 14px;
                    right: 32px;
                }
            `,
            modalContent: css`
                padding: 0 20px 20px;

                ${TypographyStyle} {
                    font-size: 14px;
                    color: ${ADIColors.black};
                }
            `,
        },
    },
    CompareButtonContainer: {
        css: css`
            text-align: right;
            margin-top: 20px;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme, [css` text-align: left; `,],);
            }}
            a {
                display: inline-block;
                ${TypographyStyle} {
                    font-size: 16px;
                    color: ${ADIColors.white};
                }
            }
        `,
    },
    availabilityByWarehouseModal: {
        sizeVariant: "medium",
        closeButtonIconProps: {
            src: CrossIcon,
            size: 20,
        },
        cssOverrides: {
            modalBody: css`
                max-width: 730px !important;
                border-radius: 4px;
                padding: 28px !important;
            `,
            modalContent: css`
                padding: 0;
            `,
            modalTitle: css`
                border-bottom: 0;
                padding: 0 !important;
                margin-bottom: 20px;
                > h4 {
                    font-size: 32px;
                    font-weight: bold;
                    font-family: "Nunito Sans", sans-serif;
                    line-height: normal;
                    color: ${ADIColors.darkBlue1};
                }
                button {
                    border-radius: 0;
                    svg {
                        height: 20px;
                    }
                }
            `,
            headlineTypography: css`
                font-size: 20px;
                margin-bottom: 0;
            `,
        },
    },
};

const ADIProductListCard: React.FC<Props> = ({
    product,
    view,
    showBrand,
    showPartNumbers,
    showPrice,
    showAvailability,
    productSettings,
    extendedStyles,
    isAuthenticated,
    session,
    productLine,
    isProductCompareFull,
    showCompare,
    productComparePageLink,
    addProductToCompare,
    removeProductFromCompare,
    state,
    catalogRootPath,
    showADIAddToCart,
    showADIAddToList,
    productInfo,
    sourceName,
    customerNumber,
}) => {
    const getProductCompareChecked = () => {
        if (product) {
            return state.components.compareProductsDrawer.productsIds.includes(product.id);
        }
        return false;
    };

    const [styles] = React.useState(() => mergeToNew(adiProductListCardStyles, extendedStyles));
    const [isOpen, setIsOpen] = React.useState<boolean>(false);
    const [productCompareChecked, setProductCompareChecked] = React.useState<boolean>(getProductCompareChecked());
    const [showModal, setShowModal] = React.useState<boolean>(false);
    const [selectedProduct, setSelectedProduct] = React.useState<string>("");
    const [dealerModalIsOpen, setDealerModalIsOpen] = React.useState(false);

    const addToListOpen = (id: string) => {
        setSelectedProduct(id);
        setIsOpen(prev => !prev);
    };

    const getCertified = () => {
        setDealerModalIsOpen(true);
    };

    const dealerModalCloseHandler = () => {
        setDealerModalIsOpen(false);
    };

    if (!product) {
        return null;
    }
    const freeShippingAmount = Number(session.properties.freeshipThresholdAmt);
    const pricing = productInfo?.pricing || product.pricing;

    const handleChanged = (_: React.SyntheticEvent, value: boolean) => {
        if (value && isProductCompareFull) {
            setShowModal(true);
        } else if (value) {
            addProductToCompare({ productId: product.id });
            setProductCompareChecked(true);
        } else {
            removeProductFromCompare({ productId: product.id });
            setProductCompareChecked(false);
        }
    };

    const closePopup = () => {
        setShowModal(false);
    };


    const isPendingVerification = useSelector(
        (state: CustomApplicationState) => state.ADIGlobalData.PricingStatusStore.isPendingVerification,
    );

    const showAuthorizationRequired =
        pricing &&
            pricing.additionalResults &&
            pricing.additionalResults.isVisible &&
            pricing.additionalResults.isVisible === "N"
            ? "true"
            : "false";
    const vendorAuthRequiredList = product?.properties?.vendorAuthRequiredList?.toLowerCase();
    const brandName = product.brand?.name ?? "";
    const vendorAuthRequiredLink = product?.properties?.vendorAuthRequiredLink;

    const clickHandler = () => {
        pushDealerAuthDataToDataLayer(
            brandName,
            vendorAuthRequiredLink,
            customerNumber,
            "Product List",
            session,
        );
    };

    return (
        <StyledWrapper {...styles.wrapper} data-test-selector={`productListProductCard${product.id}`}>
            <ADIProductSaleInfo product={product} isAuthenticated={isAuthenticated} pricing={pricing} />
            <StyledWrapper {...styles.imageWrapper}>
                {product.isSponsored && <Typography {...styles.sponsoredText}>{translate("Sponsored")}</Typography>}
                <ADIProductImage product={product} sourceName={sourceName || "Product List Page"} />
                {showCompare &&
                    productSettings.enableProductComparisons &&
                    window.location.pathname.includes("shopmybranch") && (
                        <Hidden below="lg">
                            <Checkbox
                                checked={productCompareChecked}
                                {...styles.checkBoxContainerStyle}
                                onChange={handleChanged}
                            >
                                {translate("Compare")}
                            </Checkbox>
                        </Hidden>
                    )}
            </StyledWrapper>
            <StyledWrapper {...styles.contentWrapper}>
                <StyledWrapper>
                    {product.brand && showBrand && (
                        <ADIProductBrandName
                            brandName={product.brand?.name}
                            brandUrl={catalogRootPath + product.brand?.detailPagePath}
                            extendedStyles={styles.brandStyles}
                        />
                    )}
                    <ADIProductDescription
                        sourceName={sourceName || "Product List Page"}
                        session={session}
                        product={product}
                        extendedStyles={styles.descriptionStyles}
                    />
                    {showPartNumbers && (
                        <ADIProductPartNumbers
                            product={product}
                            view={view}
                            extendedStyles={styles.productPartNumberStyle}
                        />
                    )}
                    {product.properties.featureBullets1to3 ? (
                        <StyledWrapper {...styles.featuresContainer}>
                            <Typography {...styles.featuresTitle}>{translate("Key Features")}</Typography>
                            <StyledWrapper {...styles.features}>
                                {parse(product.properties.featureBullets1to3, parserOptions)}
                            </StyledWrapper>
                        </StyledWrapper>
                    ) : null}
                    {showAvailability && (
                        <ADIProductAvailability
                            product={product}
                            view={view}
                            showAuthorizationRequired={showAuthorizationRequired}
                        />
                    )}
                </StyledWrapper>
            </StyledWrapper>
            {isAuthenticated && (
                <StyledWrapper {...styles.actionWrapper}>
                    {showAuthorizationRequired === "false" ? (
                        <>
                            {showPrice && (
                                <ADIProductPrice
                                    product={product}
                                    showSavings={true}
                                    showUnitOfMeasure={false}
                                    showSavingsAmount={productSettings.showSavingsAmount}
                                    showSavingsPercent={productSettings.showSavingsPercent}
                                />
                            )}
                            {showADIAddToCart && (
                                <ADIProductAddToCartButton
                                    productLine={product}
                                    buttonLabel="Add To Cart"
                                    extendedStyles={styles.addToCartStyles}
                                    sourceName="Recently Purchased Products"
                                />
                            )}
                            {showADIAddToList && (
                                <StyledWrapper {...styles.addToListWrapper} id="addtolist">
                                    <Typography {...styles.addToListText} onClick={() => addToListOpen(product.productNumber)}>
                                        {translate("Add To List")}
                                        <FilterDown />
                                    </Typography>
                                    {productLine && selectedProduct === product.productNumber && (
                                        <CustomAddToList isOpen={isOpen} productInfos={productLine} setIsOpen={setIsOpen} />
                                    )}
                                </StyledWrapper>
                            )}
                            <ADIProductDeliveryInfo
                                product={product}
                                freeShippingAmount={freeShippingAmount}
                                showAuthorizationRequired={showAuthorizationRequired}
                            />
                        </>
                    )
                        : vendorAuthRequiredList === "true" && !isPendingVerification ? (
                            <StyledWrapper data-test-selector="dealerBtn" {...styles.dealerBtnWrapper}>
                                {localStorage.getItem("CreditStatus") !== "O" && localStorage.getItem("CreditStatus") !== "" && localStorage.getItem("CreditStatus") !== null ? <Typography {...styles.VerificationText}>{translate("Account Pending Verification")}</Typography> :
                                    <><StyledWrapper {...styles.dealerBtn}>Dealer Certification Required </StyledWrapper>
                                        <Link {...styles.certifiedBtn} onClick={getCertified}>
                                            Get Certified
                                        </Link>
                                    </>}

                                <Modal
                                    {...styles.availabilityByWarehouseModal}
                                    headline={translate("Dealer Certification Required")}
                                    isOpen={dealerModalIsOpen}
                                    handleClose={dealerModalCloseHandler}
                                >
                                    {siteMessage("Dealer_Vendor_Certification_Message")}
                                    <Link
                                        href={product.properties?.vendorAuthRequiredLink}
                                        target="_blank"
                                        onClick={clickHandler}
                                    >
                                        {" "}
                                        {translate("vendor's form.")}
                                    </Link>{" "}
                                    {translate("For more information, call ")}
                                    <StyledWrapper as="span">1.877.228.6739.</StyledWrapper>
                                    <Button onClick={dealerModalCloseHandler}>Continue Shopping</Button>
                                </Modal>
                            </StyledWrapper>
                        ) : (
                            <>
                                {!isPendingVerification && (
                                    <StyledWrapper data-test-selector="dealerBtn" {...styles.dealerBtnWrapper}>

                                        {localStorage.getItem("CreditStatus") !== "O" && localStorage.getItem("CreditStatus") !== "" && localStorage.getItem("CreditStatus") !== null ? <Typography {...styles.VerificationText}>{translate("Account Pending Verification")}</Typography> : <>
                                            <StyledWrapper {...styles.dealerBtn}>
                                                Dealer Certification Required
                                            </StyledWrapper>
                                            <Link {...styles.certifiedBtn} onClick={getCertified}>
                                                Get Certified
                                            </Link>
                                        </>}

                                        <Modal
                                            {...styles.availabilityByWarehouseModal}
                                            headline={translate("Dealer Certification Required")}
                                            isOpen={dealerModalIsOpen}
                                            handleClose={dealerModalCloseHandler}
                                        >
                                            {siteMessage("Dealer_Certification_Message")}
                                            <Button onClick={dealerModalCloseHandler}>Continue Shopping</Button>
                                        </Modal>
                                    </StyledWrapper>
                                )}
                            </>

                        )}
                </StyledWrapper>
            )}

            {/* <Modal
                headline={<Typography>{siteMessage("ProductionCompare_MaximumItemsReached")}</Typography>}
                {...styles.compareWarningPopup}
                isOpen={maximumCompareReached}
                handleClose={closePopup}
            >
                <StyledWrapper>
                    <Typography>{translate(`Please 'Compare' or remove items.`)}</Typography>
                    <StyledWrapper {...styles.CompareButtonContainer}>
                        <Clickable href={productComparePageLink?.url}>
                            <Button>{translate("Compare Items")}</Button>
                        </Clickable>
                    </StyledWrapper>
                </StyledWrapper>
            </Modal> */}
            <Modal
                headline={<Typography>{siteMessage("ProductionCompare_MaximumItemsReached")}</Typography>}
                {...styles.compareWarningPopup}
                isOpen={showModal}
                handleClose={closePopup}
            >
                <StyledWrapper>
                    <Typography>{translate(`Please 'Compare' or remove items.`)}</Typography>
                    <StyledWrapper {...styles.CompareButtonContainer}>
                        <Clickable href={productComparePageLink?.url}>
                            <Button>{translate("Compare")}</Button>
                        </Clickable>
                    </StyledWrapper>
                </StyledWrapper>
            </Modal>
        </StyledWrapper>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(ADIProductListCard);
